export default __webpack_public_path__ + "static/media/Grid3.4.292619ad.jpg";